import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Tab} from '@common-module/app-enums/tab';
import {AuthUserService} from "@common-module/app-services/auth-user.service";

@Component({
    selector: 'app-admin-login-form',
    templateUrl: './admin-login-form.component.html',
})

export class AdminLoginFormComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
              private authUserService: AuthUserService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const actAs = params['user_id'];
      if (actAs) {
        this.authUserService.updateActAs(actAs);
      }
      this.router.navigate([Tab.MAP]).then();
    });
  }
}
